import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useI18n } from "../../contexts/I18nContext";
import { formatApiError } from "../../lib/api";
import LegendsMark from "../../components/LegendsMark";

export default function AdminLogin() {
    const { user, login, loading } = useAuth();
    const { t, lang } = useI18n();
    const navigate = useNavigate();
    const [email, setEmail] = useState("admin@legends.sa");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    if (loading) return null;
    if (user && user !== false) return <Navigate to="/admin" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            await login(email, password);
            navigate("/admin");
        } catch (e) {
            setErr(formatApiError(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#002951] text-white grid lg:grid-cols-2 relative overflow-hidden" data-testid="admin-login-page">
            <div className="grain-overlay" />
            <div className="relative hidden lg:flex flex-col justify-between p-12 border-r border-white/10">
                <div className="heading text-3xl tracking-tighter inline-flex items-center gap-2">LEGENDS<LegendsMark size={26} color="#0060A7" /></div>
                <div>
                    <div className="text-xs uppercase tracking-[0.3em] text-white/40 mb-6 plus-mark">{t("admin_dashboard")}</div>
                    <h1 className="heading text-5xl md:text-6xl tracking-tighter leading-[1.05]">
                        {lang === "ar" ? "إدارة الموقع باحترافية." : "Manage with precision."}
                    </h1>
                    <p className="mt-6 text-white/60 max-w-md text-lg leading-relaxed">
                        {lang === "ar"
                            ? "لوحة تحكم متعددة الصلاحيات للأعمال، الأخبار، والخدمات."
                            : "Role-based control center for works, news, and services."}
                    </p>
                </div>
                <div className="text-xs uppercase tracking-[0.3em] text-white/30">
                    Insights. Influence. Legacy.
                </div>
            </div>
            <div className="relative flex items-center justify-center p-8">
                <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="admin-login-form">
                    <LegendsMark size={20} color="#0060A7" className="mb-6" />
                    <h2 className="heading text-4xl tracking-tighter mb-2">{t("login_title")}</h2>
                    <p className="text-white/50 text-sm mb-10">{lang === "ar" ? "أدخل بيانات الاعتماد للمتابعة." : "Enter your credentials to continue."}</p>
                    <div className="space-y-6">
                        <div>
                            <label className="text-xs uppercase tracking-[0.3em] text-white/40">{t("login_email")}</label>
                            <input
                                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                data-testid="login-email-input"
                                className="w-full bg-transparent border-b border-white/20 focus:border-[#0060A7] outline-none py-3 mt-2"
                            />
                        </div>
                        <div>
                            <label className="text-xs uppercase tracking-[0.3em] text-white/40">{t("login_password")}</label>
                            <input
                                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                                data-testid="login-password-input"
                                className="w-full bg-transparent border-b border-white/20 focus:border-[#0060A7] outline-none py-3 mt-2"
                            />
                        </div>
                    </div>
                    {err && <p className="mt-6 text-sm text-red-400" data-testid="login-error">{err}</p>}
                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="login-submit-button"
                        className="mt-10 w-full bg-white text-[#002951] hover:bg-[#0060A7] hover:text-white py-4 text-sm uppercase tracking-[0.3em] transition-colors disabled:opacity-60"
                    >
                        {busy ? "…" : t("login_submit")}
                    </button>
                </form>
            </div>
        </div>
    );
}
